/** Maps Zendesk Category ids to it‘s corresponding image */

import { Checkbox, CheckboxLarge, CreditCardBase, CreditCardLarge, ExtensionBase, ExtensionLarge, GearBase, GearLarge, Group, GroupLarge, Person, PersonLarge } from '@doist/icons/brand';
import type { ChoiceCardBackgroundColor } from '@doist/marketist';
export type IdImage = { [key in number]: {
  icon: {
    large: JSX.Element;
    small: JSX.Element;
  };
  bgColor: ChoiceCardBackgroundColor;
} };
export default {
  115000632125: {
    icon: {
      large: <PersonLarge width={32} height={32} />,
      small: <Person />
    },
    bgColor: 'red'
  },
  360002791659: {
    icon: {
      large: <CheckboxLarge width={32} height={32} />,
      small: <Checkbox />
    },
    bgColor: 'yellow'
  },
  360002791719: {
    icon: {
      large: <CreditCardLarge width={32} height={32} />,
      small: <CreditCardBase />
    },
    bgColor: 'red'
  },
  115000626249: {
    icon: {
      large: <GearLarge width={32} height={32} />,
      small: <GearBase />
    },
    bgColor: 'seaSalt'
  },
  360002791779: {
    icon: {
      large: <ExtensionLarge width={32} height={32} />,
      small: <ExtensionBase />
    },
    bgColor: 'yellow'
  },
  13521712913948: {
    icon: {
      large: <GroupLarge width={32} height={32} />,
      small: <Group />
    },
    bgColor: 'green'
  }
} as IdImage;